import ReactModal from "react-modal";
import HelpCompose from "./helpCompose";
import { useState } from "react";
import { helpContact } from "../../../../constants/pageBlocks";

const StudentHelp = () => {
  const [showCompose, setShowCompose] = useState<boolean>(false);
  const [selectedContact, setSelectedContact] = useState<number>(0);

  const handleOpenModal = () => selectedContact && setShowCompose(true)

  const handleCloseModal = () => setShowCompose(false)

  const onChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedContact(Number(event.target.value));
  };

  return (
    <>
      <div className="card-wrap  d-flex align-items-center">
        <div className="emailbot">
        <img src="/assets/images/emailbot.svg" alt="" />
          <h2>Need Help? Contact Us Here</h2>
          <p>
            I can help you reach your contacts. Select who you want and click
            'Connect'.
          </p>
          <div className="d-flex align-items-center flex-column gap-2 mt-3 w-100">
            <div className="form-group mb-2 w-100">
              <select name="" id="" className="w-100" onChange={onChange}>
                <option disabled selected>Select Contacts</option>
                <option value={helpContact.department}>Contact Department</option>
                <option value={helpContact.faculty}>Contact Faculty</option>
                <option value={helpContact.advisor}>Contact Advisor</option>
              </select>
            </div>
            <button
              className="btn btn-primary w-100"
              onClick={() => handleOpenModal()}
              disabled={selectedContact ? false : true}
            >
              Connect
            </button>
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={showCompose}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <HelpCompose
          setShowCompose={handleCloseModal}
          selectedContact={selectedContact} />
      </ReactModal>
    </>
  );
};

export default StudentHelp;
